import React from 'react';
import { data } from '../../constants';
import './Pricing.scss';



const PricingBox = ({ package: { icon, plan, price, options } }) => (

    <div className="box">

        <span className={`fas fa-${icon}`}></span>
        <h3>{plan}</h3>
        <div className="price">
            <i>$</i>{price}<i>/monthly</i>
        </div>
        <ul>
            {
                options.map(option => (
                    <li key={option + "1"}>
                        <i className="fas fa-check"></i> {option}
                    </li>))
            }
        </ul>
        <a href="/#" className="btn">chose plane</a>
    </div>
);

const Pricing = () => {
    return (
        <section className="pricing" id="pricing">

            <h1 className="heading">
                our <span>Pricing</span>
            </h1>

            <div className="box-container">
                {
                    data.pricing.map(price => (
                        <PricingBox
                            key={price.id}
                            package={price} />
                    ))
                }

            </div>

        </section>
    )
}

export default Pricing;